import { CashTypeEnum } from "../enums/CashTypeEnum";
import { TransactionBagDetails } from "./TransactionBagDetails";

export class BagsCashReportEntry {
    public installationName: string;
    public machineSerialNumber: string;
    public machineId: number;
    public currency: string;
    public cashType: CashTypeEnum;
    public bagCashInValue: number;
    public bagCashInPieces: number;
    public initialContent: number;
    public finalContent: number;
    public details: TransactionBagDetails[];

    constructor() {}

    parse(obj: any) {
        this.installationName = obj.InstallationName;
        this.machineSerialNumber = obj.MachineSerialNumber;
        this.machineId = obj.MachineId;
        this.currency = obj.Currency;
        if (obj.CashType != null && Object.values(CashTypeEnum).includes(obj.CashType)) this.cashType = obj.CashType;
        this.bagCashInValue = obj.BagCashInValue;
        this.bagCashInPieces = obj.BagCashInPieces;
        this.initialContent = obj.InitialContent;
        this.finalContent = obj.FinalContent;
        if (obj.Details && obj.Details.length > 0) {
            this.details = [];
            obj.Details.forEach((obj) => {
                var temp = new TransactionBagDetails();
                temp.parse(obj);
                this.details.push(temp);
            });
        }
    }
}
